import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

interface ProtectedRouteProps {
  children: ReactNode;
  allowedRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles = [],
}) => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (
    allowedRoles.length === 0 ||
    (user?.roles && user.roles.some((role) => allowedRoles.includes(role)))
  ) {
    return <>{children}</>;
  }

  // Redirect based on user role instead of always to /overview
  if (user?.roles.includes("worker")) {
    return <Navigate to="/expenses/record" replace />;
  } else {
    return <Navigate to="/overview" replace />;
  }
};

export default ProtectedRoute;
